import { useEffect, useRef } from "react";
import { beep } from "@/lib/beep";

const FAST_MS = 60; // handheld scanners "type" each digit within a few ms; people don't
const CODE_RX = /^[0-9]{8,14}$|^[0-9]{9}[0-9Xx]$/;
const typing = (el) => el && (el.isContentEditable || ["INPUT", "TEXTAREA", "SELECT"].includes(el.tagName));

// Plug-in (USB / Bluetooth keyboard) barcode scanners: a burst of digits then Enter, anywhere on the page.
export function useUsbScanner(onCode, enabled = true, sound = true) {
  const cb = useRef(onCode);
  cb.current = onCode;
  useEffect(() => {
    if (!enabled) return undefined;
    let buf = "", lastAt = 0, slow = false;
    const onKey = (e) => {
      if (typing(e.target) || e.ctrlKey || e.metaKey || e.altKey) return;
      const now = performance.now();
      if (now - lastAt > 300) { buf = ""; slow = false; }
      if (buf && now - lastAt > FAST_MS) slow = true;
      lastAt = now;
      if (e.key === "Enter") {
        if (!slow && CODE_RX.test(buf)) {
          e.preventDefault(); if (sound) beep(true);
          const code = buf.toUpperCase();
          window.dispatchEvent(new CustomEvent("snaplist:usb-scan", { detail: code }));
          cb.current(code);
        }
        buf = "";
        return;
      }
      if (e.key.length === 1) buf = (buf + e.key).slice(-20);
    };
    window.addEventListener("keydown", onKey, true);
    return () => window.removeEventListener("keydown", onKey, true);
  }, [enabled, sound]);
}
